/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NaturalPersonDto } from './NaturalPersonDto';
import {
    NaturalPersonDtoFromJSON,
    NaturalPersonDtoFromJSONTyped,
    NaturalPersonDtoToJSON,
    NaturalPersonDtoToJSONTyped,
} from './NaturalPersonDto';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface LegalEntityDto
 */
export interface LegalEntityDto {
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    id?: string;
    /**
     * Company or plateforme name
     * @type {string}
     * @memberof LegalEntityDto
     */
    companyName: string;
    /**
     * Unique identifier for legal form
     * @type {string}
     * @memberof LegalEntityDto
     */
    legalFormId: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof LegalEntityDto
     */
    address: AddressDto;
    /**
     * Phone number of the legal entity
     * @type {string}
     * @memberof LegalEntityDto
     */
    phone: string;
    /**
     * Email address of the legal entity
     * @type {string}
     * @memberof LegalEntityDto
     */
    email: string;
    /**
     * List of natural persons associated with this legal entity
     * @type {Array<NaturalPersonDto>}
     * @memberof LegalEntityDto
     */
    naturalPersons: Array<NaturalPersonDto>;
    /**
     * SIRET registration number
     * @type {string}
     * @memberof LegalEntityDto
     */
    registrationNumber: string;
    /**
     * Company capital amount
     * @type {number}
     * @memberof LegalEntityDto
     */
    capital: number;
    /**
     * RCS registration city
     * @type {string}
     * @memberof LegalEntityDto
     */
    rcsCity: string;
    /**
     * RCS registration number
     * @type {string}
     * @memberof LegalEntityDto
     */
    rcsNumber: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    oriasNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof LegalEntityDto
     */
    rcp?: string;
}

/**
 * Check if a given object implements the LegalEntityDto interface.
 */
export function instanceOfLegalEntityDto(value: object): value is LegalEntityDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('legalFormId' in value) || value['legalFormId'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('naturalPersons' in value) || value['naturalPersons'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('capital' in value) || value['capital'] === undefined) return false;
    if (!('rcsCity' in value) || value['rcsCity'] === undefined) return false;
    if (!('rcsNumber' in value) || value['rcsNumber'] === undefined) return false;
    return true;
}

export function LegalEntityDtoFromJSON(json: any): LegalEntityDto {
    return LegalEntityDtoFromJSONTyped(json, false);
}

export function LegalEntityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LegalEntityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'] == null ? undefined : json['id'],
        'companyName': json['companyName'],
        'legalFormId': json['legalFormId'],
        'address': AddressDtoFromJSON(json['address']),
        'phone': json['phone'],
        'email': json['email'],
        'naturalPersons': ((json['naturalPersons'] as Array<any>).map(NaturalPersonDtoFromJSON)),
        'registrationNumber': json['registrationNumber'],
        'capital': json['capital'],
        'rcsCity': json['rcsCity'],
        'rcsNumber': json['rcsNumber'],
        'oriasNumber': json['oriasNumber'] == null ? undefined : json['oriasNumber'],
        'rcp': json['rcp'] == null ? undefined : json['rcp'],
    };
}

export function LegalEntityDtoToJSON(json: any): LegalEntityDto {
    return LegalEntityDtoToJSONTyped(json, false);
}

export function LegalEntityDtoToJSONTyped(value?: LegalEntityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'companyName': value['companyName'],
        'legalFormId': value['legalFormId'],
        'address': AddressDtoToJSON(value['address']),
        'phone': value['phone'],
        'email': value['email'],
        'naturalPersons': ((value['naturalPersons'] as Array<any>).map(NaturalPersonDtoToJSON)),
        'registrationNumber': value['registrationNumber'],
        'capital': value['capital'],
        'rcsCity': value['rcsCity'],
        'rcsNumber': value['rcsNumber'],
        'oriasNumber': value['oriasNumber'],
        'rcp': value['rcp'],
    };
}

